import React from "react";
import { Toolbar as RhombusToolbar, Button } from "rhombus-react";
import Permissioned from "widgets/Permissioned";

export default function Toolbar({ searchTerm, handleSearch, libraryId }) {
	const searchProps = {
		placeholder: "Search",
	};

	return(
		<RhombusToolbar
			search
			searchProps={searchProps}
			onSearch={handleSearch}
			searchValue={searchTerm}
			className="qr-designs-search"
		>
			<div className="button-side" data-testid="qrdesigns-toolbar">
				<Permissioned
					domain="Creative View"
					action="Upload Assets"
				>
					<Button
						icon="addCircleSolid"
						style="block"
						theme="blue"
						isLink
						to={`/library/${libraryId}/qr-designs/new/`}
					>
						New QR Code Design
					</Button>
				</Permissioned>
			</div>
		</RhombusToolbar>
	);
}

Toolbar.displayName = "QrCodesToolbar";
